import { gql } from '@apollo/client';

export const GET_GROUPS = gql`
  query GetGroups($input: GroupsInput!) {
    groups: getGroups(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          startDate
          endDate
          numberOfOptions
          status
          caseManagement
          caseCategorisation
          caseManagementUse
          indicatorFramework
          indicatorFrameworkUse
          groupCode
          groupDescription
          childGroup {
            id
            name
          }
        }
      }
    }
  }
`;
